// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');
const errorCodes = require('constants/contactCenter/cancelBizumErrorCodes');
const { EURO_TEXT } = require('constants/index');
// @ utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { getSecurityDataValid } = require('utilities/contactCenter/bizumActionsHelper');

const validateStep = (step) => ({
    type: actionTypes.BIZUM_CANCEL_VALIDATE_STEP,
    payload: {
        step
    }
});

const setVisibleStep = (step) => ({
    type: actionTypes.BIZUM_CANCEL_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const postCancelBizumStart = () => ({
    type: actionTypes.BIZUM_CANCEL_SAVE_START
});

const postCancelBizumSuccess = response => ({
    type: actionTypes.BIZUM_CANCEL_SAVE_SUCCESS,
    payload: Object.assign({}, response)
});

const postCancelBizumFailure = error => ({
    type: actionTypes.BIZUM_CANCEL_SAVE_FAILURE,
    payload: {
        error
    }
});

const postCancelBizumInvalidSecurityDataError = () => ({
    type: actionTypes.BIZUM_CANCEL_INVALID_SECURITY_DATA_ERROR
});

const queryContractStart = () => ({
    type: actionTypes.BIZUM_CANCEL_QUERY_CONTRACT_START
});

const queryContractSuccess = response => ({
    type: actionTypes.BIZUM_CANCEL_QUERY_CONTRACT_SUCCESS,
    payload: Object.assign({}, response)
});

const queryContractFailure = error => ({
    type: actionTypes.BIZUM_CANCEL_QUERY_CONTRACT_FAILURE,
    payload: {
        error
    }
});

const queryContract = () => dispatch => {
    dispatch(queryContractStart());

    return APIGet({ endpoint: 'bizumQueryContract', dispatch })
        .then(response => {
            if (!!response.error) {
                dispatch(queryContractFailure(response));
            } else {
                dispatch(queryContractSuccess(response));
            }
        })
        .catch(response => {
            if(!!response.error) {
                dispatch(queryContractFailure(response.body));
            } else {
                throw response;
            }
        });
}

const isSecurityDataValid = immSignaturePattern => {
    if (immSignaturePattern.get('requiredDigits') && !immSignaturePattern.get('consumerFinishInputDigits')) {
        return false;
    }

    if (immSignaturePattern.get('requiredSMS') && (immSignaturePattern.get('inputValueSMS').trim() === '' || !immSignaturePattern.get('isSMSValid'))) {
        return false;
    }

    return true;
};

const postCancelBizum = () => (dispatch, getState) => {
    const signaturePattern = getState().signaturePattern;
    const printer = getState().printer;

    if (!isSecurityDataValid(signaturePattern)) {
        dispatch(postCancelBizumInvalidSecurityDataError());
        return;
    }

    dispatch(postCancelBizumStart());

    const cancelBizum = getState().cancelBizum;

    const securityCheck = getSecurityDataValid(signaturePattern, printer);

    const dataToken = signaturePattern.get('token');

    const params = {
        query: {
            codIBANCodbBan: cancelBizum.getIn(['fetchResponse', 'codIBANCodbBan'], ''),
            codIBANDigitoControl: cancelBizum.getIn(['fetchResponse', 'codIBANDigitoControl'], ''),
            codIBANPais: cancelBizum.getIn(['fetchResponse', 'codIBANPais'], ''),
            codigoOTP: securityCheck,
            currency: EURO_TEXT,
            telefono: cancelBizum.getIn(['fetchResponse', 'telefono'], ''),
            tokenFirma: dataToken
        }
    };

    return APIPost({ dispatch, endpoint: 'bizumUnsuscribeClient', params })
        .then(response => {
            if (response.error === undefined || response.error === errorCodes.SUCCESS) {
                dispatch(postCancelBizumSuccess(response));
            } else if (response.errorDescription === 'Bad Request') {
                dispatch(postCancelBizumInvalidSecurityDataError());
            } else {
                dispatch(postCancelBizumFailure(response));
            }
        })
        .catch(response => {
            if(!!response.error) {
                dispatch(postCancelBizumFailure(response.body));
            } else {
                throw response;
            }
        });
};

const clearRequest = () => ({
    type: actionTypes.BIZUM_CANCEL_CLEAR_REQUEST
});

module.exports = {
    queryContract,
    validateStep,
    setVisibleStep,
    postCancelBizum,
    clearRequest,
};
